<template>
    <div class="header__options__item">
        <button role="button" class="notifications" :class="{ 'has-notifications' : hasNotifications }" :title="$t('nav.notifications')" @click="onMarkNotificationsAsRead" tabindex="-1">
            {{ $t('nav.notifications') }}
        </button>
        <div class="header__dropdown">
            <div class="header__dropdown__wrapper" v-bar>
                <div>
                <div class="notifications notifications--overview loading-wrapper" :class="{ 'is-loading' : loading }">
                        <div class="loading-message">{{ this.$t('results_loading') }}</div>
                        <template v-if="notificationsCount === 0">
                            <div class="notifications--overview__empty-item">
                                {{ $t('notifications.no_results_found') }}
                            </div>
                        </template>
                        <template v-for="item in notifications">
                            <div class="notifications--overview__item">
                                <router-link :to="item.route" :title="item.title" tabindex="-1">
                                    <h2>{{ item.title }}</h2>
                                    <p>{{ item.description }}</p>
                                </router-link>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props : {
            interval : {
                type : Number,
                default : 60
            }
        },
        data() {
            return {
                loading                 : false,
                notifications           : [],
                notificationsCount      : 0,
                hasReadNotifications    : false
            };
        },
        computed : {
            hasNotifications : function () {
                return this.hasReadNotifications && this.notificationsCount >= 1;
            }
        },
        created : function () {
            this.onUpdateNotifications();

            setInterval((function () {
                this.onUpdateNotifications();
            }).bind(this), parseInt(this.interval) * 1000);
        },
        methods : {
            onUpdateNotifications : function () {
                let promise = this.$api.clearParams()
                    .addParam('unread', 1)
                    .setPageParams(1, 10)
                    .get('notifications');

                promise.then((response => {
                    var items = [];

                    response.data.data.forEach((function (item) {
                        var type = item.entity.split('\\').pop().toLowerCase();

                        if (type === 'project') {
                            items.push({
                                id              : item.id,
                                title           : this.$t('home.notifications.project_' + item.event, {
                                    project_number  : item.object.data.project_number,
                                }),
                                description     : this.$t('home.notifications.project_' + item.event + '.desc', {
                                    project_number  : item.object.data.project_number,
                                    company         : item.object.data.location.company_name
                                }),
                                route       : { name : 'customers-view-customer-project', params : { customer : item.customer_id, project : item.entityId } }
                            })
                        }
                    }).bind(this));

                    this.notifications      = items;
                    this.notificationsCount = items.length;

                    this.loading            = false;
                }).bind(this)).catch((error => {
                    this.notifications      = [];
                    this.notificationsCount = 0;

                    this.loading            = false;
                }).bind(this));

                this.loading                = true;
                this.hasReadNotifications   = false;
            },
            onMarkNotificationsAsRead : function () {
                var object = {
                    notifications : []
                };

                this.notifications.forEach((function (notification) {
                    object.notifications.push(notification.id);
                }).bind(this));

                let promise = this.$api.clearParams()
                    .post('notifications/read', object);

                promise.then((response => {
                    this.hasReadNotifications = true;
                }).bind(this)).catch((error => {
                    console.log(error);
                }).bind(this));
            }
        }
    }
</script>